import React, { useContext } from 'react';
import LocalizationContext from '../../contexts/Localizations';
import { Rider as RiderDetailsProps } from '../../core/typings/riders';
import { Container } from '../helpers/Grid';
import './styles.scss';

const RiderDetails = ({
  givenName,
  familyName,
  location,
  dob,
  nationality,
  sanctions,
}: RiderDetailsProps) => {
  const { translations } = useContext(LocalizationContext);
  return (
    <section className="rider-details">
      <Container>
        <div className="rider-details__inner">
          <div className="rider-details__body">
            <div className="rider-details__name">
              {givenName}
              <span>{familyName}</span>
            </div>
            <div className="rider-details__location">
              {location}
            </div>
          </div>
          <div className="rider-details__footer">
            {nationality && (
              <div className="rider-details__footer-item">
                <div className="rider-details__footer-item__label">
                  {translations.riders.nationalityLabel}
                </div>
                <div className="rider-details__footer-item__value">
                  {nationality.replace('RU', '**').replace('BY', '**')}
                </div>
              </div>
            )}
            {dob && (
              <div className="rider-details__footer-item">
                <div className="rider-details__footer-item__label">
                  {translations.riders.dobLabel}
                </div>
                <div className="rider-details__footer-item__value">
                  {dob}
                </div>
              </div>
            )}
            {dob && (
              <div className="rider-details__footer-item">
                <div className="rider-details__footer-item__label">
                  {translations.riders.sanctionsLabel}
                </div>
                <div className="rider-details__footer-item__value">
                  {sanctions}
                </div>
              </div>
            )}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default RiderDetails;
